<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="d-flex flex-column">
    @if (showBackButton) {
      <small class="d-print-none">
        @if (!isList) {
          <a
            class="text-primary cursor-pointer"
            style="text-decoration: none"
            (click)="backClicked()"
          >
            <i class="far fa-chevron-left me-2"></i>Voltar
          </a>
        }
      </small>
    }

    <h4>{{ pageTitle }}</h4>
  </div>

  @if (showButton && !nextButton) {
    <button
      mat-flat-button
      type="button"
      color="primary"
      (click)="buttonClicked()"
      [disabled]="isBusy"
    >
      <i
        class="me-2 far"
        [class]="(buttonIcon ?? isList) ? 'fa-plus' : 'fa-check'"
      ></i>
      {{ buttonText ?? (isList ? "Adicionar" : "Confirmar") }}
    </button>
  }

  @if (showButton && nextButton) {
    <button
      mat-flat-button
      type="button"
      color="primary"
      (click)="buttonClicked()"
      [disabled]="isBusy"
    >
      <i class="me-2 far fa-arrow-right"></i>Avançar
    </button>
  }
</div>
